module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_jungle-c1d2e6ee97aeba0ca77f28fdf1a60b3c.jpg";